// Per-route SEO metadata. Descriptions summarize what each page already says,
// no new claims, figures or product statements are introduced here.

import { SITE_URL } from "@/components/SEO";

// Single approved, genuine WearSpray product photo (real Safe Band Pro reservoir
// face, press-to-dispense) used as the og:image / twitter:image on every route.
// 1200x630, matches the required social-card aspect ratio exactly.
const OG_IMAGE = `${SITE_URL}/og/wearspray-social-preview-v2.jpg`;

// Product schema for /products (Safe Band Pro). Price is intentionally omitted
// since it is not published on the page itself, no figure is invented here.
export const SAFE_BAND_PRODUCT_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Safe Band Pro",
  image: OG_IMAGE,
  description:
    "Safe Band Pro is WearSpray's patented, refillable wrist-worn dispensing platform that keeps a chosen formulation, sunscreen, lotion, repellent or sanitizer, immediately accessible with a single press.",
  brand: { "@type": "Brand", name: "WearSpray" },
  offers: {
    "@type": "Offer",
    url: "https://safebandpro.com",
    availability: "https://schema.org/InStock",
  },
};

export const PAGE_SEO = {
  "/": {
    title: "WearSpray: Wearable Sunscreen Dispenser & Reapplication Wearable",
    description:
      "WearSpray is a patented, wrist-worn refillable dispenser that puts your sunscreen, lotion or repellent one press away, so reapplication actually happens.",
    image: OG_IMAGE,
  },
  "/why": {
    title: "Why WearSpray: The Case For Wearing Your Protection",
    description:
      "Reapplication is where sun protection usually fails. See why a wrist-worn, refillable dispenser closes the gap between knowing and doing.",
    image: OG_IMAGE,
  },
  "/technology": {
    title: "Technology: How WearSpray's Dispensing Platform Works",
    description:
      "Inside the patented micro-dispensing valve, refillable reservoir and sensor layer that turn a compatible sunscreen or lotion into an on-body, one-press dispenser.",
    image: OG_IMAGE,
  },
  "/science": {
    title: "The Science: Evidence Behind WearSpray",
    description:
      "The reapplication research, survey data and dermatology guidance that shaped WearSpray's wearable, refillable dispensing design.",
    image: OG_IMAGE,
  },
  "/products": {
    title: "Safe Band Pro: WearSpray's Wearable Dispensing Band",
    description:
      "Meet Safe Band Pro: a refillable, reusable wrist-worn reservoir for sunscreen, lotion, repellent or sanitizer, ready in a single press.",
    image: OG_IMAGE,
  },
  "/patents": {
    title: "Patents & IP: WearSpray's Wearable Dispensing Patents",
    description:
      "WearSpray holds issued U.S. patents covering its wearable dispensing architecture. Explore the claims behind the technology.",
    image: OG_IMAGE,
  },
  "/clinical": {
    title: "Clinical Recovery & Aesthetics: WearSpray For Post-Procedure Compliance",
    description:
      "An early-stage concept exploring how a sealed, wearable dispensing platform could help close the gap between personalized skincare recommendations and patient adherence.",
    image: OG_IMAGE,
  },
  "/platform": {
    title: "Platform: What WearSpray Physically Enables",
    description:
      "The patented dispensing mechanism, the manufactured wrist dispenser shipping today, and the future phone-reservoir and smartwatch pod concepts extending the same architecture.",
    image: OG_IMAGE,
  },
  "/intelligence": {
    title: "Technology: WearSpray IQ, Sensing & AI Personalization",
    description:
      "WearSpray IQ, AI personalization and contextual sensing, a technology ecosystem in development, grounded in dermatology research and the issued patents already protecting it.",
    image: OG_IMAGE,
  },
  "/applications": {
    title: "Applications: Where WearSpray's Platform Can Go",
    description:
      "One patented dispensing architecture applied across medical aesthetics, consumer skincare, healthcare, personal protection and global health.",
    image: OG_IMAGE,
  },
  "/vision": {
    title: "Vision: Where WearSpray's Platform Is Headed",
    description:
      "From a wearable dispenser to a broader personal-care platform: how WearSpray's roadmap and adjacent-market thinking connect.",
    image: OG_IMAGE,
  },
  "/global-health": {
    title: "Global Health: WearSpray For Malaria Prevention",
    description:
      "Daytime protection for the hours bed nets can't cover. See how a refillable, wearable repellent dispenser reaches vulnerable communities.",
    image: OG_IMAGE,
  },
  "/market": {
    title: "Market Opportunity: WearSpray's Addressable Audience",
    description:
      "Population data, region snapshots and the research behind WearSpray's core, need-based market across the U.S., Europe and the Caribbean.",
    image: OG_IMAGE,
  },
  "/about": {
    title: "About WearSpray: Our Story & Mission",
    description:
      "Learn who is building WearSpray and why: a patented wearable platform designed to put protection exactly where and when it's needed.",
    image: OG_IMAGE,
  },
  "/contact": {
    title: "Contact WearSpray: Get In Touch",
    description:
      "Questions about WearSpray, partnerships or press? Reach the team directly at greg@wearspray.com.",
    image: OG_IMAGE,
  },
  "/investors": {
    title: "WearSpray: Pitch Deck",
    description:
      "The problem, the platform and the ask: WearSpray's patented wearable dispensing platform, explained in eight slides.",
    image: OG_IMAGE,
  },
};
